import { renderTooltip } from "./shared";

export function workflowTooltip(item) {
  // Parse the options array from JSON string
  let options = [];
  try {
    options = JSON.parse(item.options || "[]");
  } catch (e) {
    console.error("Failed to parse workflow options:", e);
    options = [];
  }

  // Define the scale items for workflow (0-6 positions)
  const scaleItems = [
    { index: 0, countField: "zero_position_count" },
    { index: 1, countField: "one_position_count" },
    { index: 2, countField: "two_position_count" },
    { index: 3, countField: "three_position_count" },
    { index: 4, countField: "four_position_count" },
    { index: 5, countField: "five_position_count" },
    { index: 6, countField: "six_position_count" },
  ];

  return renderTooltip(
    {
      itemTypeLabel: "Workflow",
      surveyText: item.prompt,
      scoringMethod: "Average value",
      hideScoringMethod: true,
      scaleItems,
      options,
    },
    item,
    "count",
  );
}
